import type {
  GuildWarCandidateAbsence,
  GuildWarCandidatePoolMember,
} from "@/core/guild-war/types"
import type {
  CandidatePoolMember,
  CandidatePoolResponse,
} from "@/lib/guild-war-wire-types"

import {
  isMartialPathCode,
  isMartialPathKey,
  MARTIAL_PATH_KEY_BY_CODE,
} from "@/core/guild-war/path-registry"

export function resolveMartialArtPath(
  value: CandidatePoolMember["primaryPathCode"],
): GuildWarCandidatePoolMember["primaryPathCode"] {
  if (value === null) return null
  if (isMartialPathKey(value)) return value
  if (isMartialPathCode(value)) return MARTIAL_PATH_KEY_BY_CODE[value]
  return null
}

export function toCoreCandidate(
  m: CandidatePoolMember,
): GuildWarCandidatePoolMember {
  return {
    ...m,
    primaryPathCode: resolveMartialArtPath(m.primaryPathCode),
    secondaryPathCode: resolveMartialArtPath(m.secondaryPathCode),
    overlappingAbsences: m.overlappingAbsences.map(
      (a): GuildWarCandidateAbsence => ({
        ...a,
        startAt: new Date(a.startAt),
        endAt: new Date(a.endAt),
      }),
    ),
  }
}

export const selectCoreCandidatePool = (
  data: CandidatePoolResponse,
): Omit<CandidatePoolResponse, "items"> & {
  items: GuildWarCandidatePoolMember[]
} => ({
  ...data,
  items: data.items.map(toCoreCandidate),
})
